import { PlusOutlined } from '@ant-design/icons';
import { Divider, Typography } from 'antd';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, SpacingRowJustify } from 'components/ui';
import { useToggleState } from 'hooks/';
import { useEditFormStore } from 'stores/local';

import s from './AddFieldsHint.module.scss';

// todo: добавить анимацию на переходы между состояниями
const AddFieldsHint: React.FC = () => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  const { toggle, opened } = useToggleState(true);

  const handleCustomFieldAdd = React.useCallback(() => {
    editFormStore.formStore.handleCustomFieldAdd();
  }, [editFormStore.formStore]);

  if (!opened) {
    return (
      <div className={cn(s.hint, s.hint_collapsed)}>
        <PlusOutlined
          onClick={toggle}
          className={cn(s.hint__icon, s.hint__icon_collapsed)}
        />
      </div>
    );
  }

  return (
    <div className={s.hint}>
      <SpacingRow justify={SpacingRowJustify.spaceBetween}>
        <Typography.Text
          className={s.hint__title}
          onClick={handleCustomFieldAdd}
        >
          {t('editForm.createField')}
        </Typography.Text>
        <Typography.Text className={s.hint__description}>
          {t('editForm.ctrlM')}
        </Typography.Text>
      </SpacingRow>
      <Divider className={s.hint__divider} />
      <SpacingRow justify={SpacingRowJustify.spaceBetween}>
        <Typography.Text
          onClick={editFormStore.catalogDrawerControllerStore.open}
          className={s.hint__title}
        >
          {t('editForm.addFromCatalog')}
        </Typography.Text>
        <Typography.Text className={s.hint__description}>
          {t('editForm.ctrlK')}
        </Typography.Text>
      </SpacingRow>
      <SpacingRow justify={SpacingRowJustify.end}>
        <PlusOutlined onClick={toggle} className={s.hint__icon} />
      </SpacingRow>
    </div>
  );
};

export default observer(AddFieldsHint);
